import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/User';
import { HttpClient } from '@angular/common/http';
import { URL_API } from '../global/config';
import { map } from 'rxjs/operators';
import { register } from 'ol/proj/proj4';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private _urlEndPoint: string = URL_API.UrlApi+'/api/v1/users';
  private _userSubject: BehaviorSubject<User>;
  user: Observable<User>;


constructor(
  
  private _router: Router,
  private _http: HttpClient
) { 
  //recuperamos la información de "user" del LocalStorage:
  this._userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
  this.user = this._userSubject.asObservable();

  console.log(JSON.parse(localStorage.getItem('user')));
  

}

get userValue(): User {
  return this._userSubject.value;
}

login(email: string, password: string){
  return this._http.post<User>(`${this._urlEndPoint}/signin`, { email, password}).pipe(
    map( user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      //guardamos en el LocalStorage el valor del Objeto: User
      localStorage.setItem('user', JSON.stringify(user));
      this._userSubject.next(user);
      return user;
    })
  )
}

logout(){
  // remove user from local storage and set current user to null
  localStorage.removeItem('user');
  this._userSubject.next(null);
  //redirige al Login 
  this._router.navigate(['/account/login']);
}

register(user: User){
  return this._http.post(`${this._urlEndPoint}/signup`, user);
}

getAll():Observable<User[]>{
  return this._http.get<User[]>(`${this._urlEndPoint}`);
}

getById(id: string): Observable<User> {
  return this._http.get<User>(`${this._urlEndPoint}/${id}`)
}

update(id: any, params: any) {
  return this._http.put(`${this._urlEndPoint}/${id}`, params).pipe(
    map( x => {
      // update stored user if the logged in user updated their own record
      if (id == this.userValue.id){
        // update local storage
        const user = { ...this.userValue, ...params};
        localStorage.setItem('user', JSON.stringify(user));

        // publish updated user to subscribers
        this._userSubject.next(user);
      }
      return x;
    })
  )
}

delete(id: any){
  return this._http.delete(`${this._urlEndPoint}/${id}`).pipe(
    map( x => {
      if (id == this.userValue.id){

        this.logout();

      }
      return x;
    })
  )
}

}
